export default "__VITE_ASSET__DBVjXz_A__"